import { Box, Center, LoadingOverlay, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip as RechartsTootip,
  XAxis,
  YAxis,
} from 'recharts';

import { getMetricsPage, MetricsPageItem, useChartDatas, useBot } from '@mygpt/app';

import CustomContainer from '@/components/CustomContainer';
import CustomContainerHeader from '@/components/CustomContainer/CustomContainerHeader';
import CustomTooltip from '@/components/Dashboard/Chart/components/CustomTooltip';
import ChartTable from '@/components/Dashboard/ChartTable';
import { SvgNoData } from '@/components/Dashboard/icon';

const PopularityInteractions = () => {
  const { t } = useTranslation();
  const { botId } = useBot();
  const { rangeDate } = useChartDatas();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<MetricsPageItem[]>([]);

  const init = () => {
    const params = {
      robot_id: botId,
      start_date: rangeDate[0]?.toString() || '',
      end_date: rangeDate[1]?.toString() || '',
      size: 1000,
    };
    getMetricsPage(params)
      .then((res) => {
        setData(res.data.items);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (rangeDate.length) init();
  }, [rangeDate]);

  return (
    <>
      <CustomContainerHeader
        title={t('dashboard.card.popularity_interactions')}
        label={t('dashboard.card.popularity_interactions_tip')}
      />
      <CustomContainer>
        <Stack gap={50}>
          <Box
            w={'100%'}
            h={350}
            className="relative flex items-center justify-center text-sm text-[#667085] font-light"
          >
            <LoadingOverlay visible={loading} overlayProps={{ blur: 2 }} />
            {data.length ? (
              <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                  width={500}
                  height={400}
                  data={data}
                  barGap={48}
                  barCategoryGap={48}
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20,
                  }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis
                    axisLine={false}
                    tickLine={false}
                    tickMargin={10}
                    padding={{ left: 45 }}
                    dataKey="url"
                    tick={false}
                  />
                  <YAxis axisLine={false} tickLine={false} tickMargin={10} />
                  <RechartsTootip
                    content={
                      <CustomTooltip
                        text={{
                          message_count: t('dashboard.card.number_messages'),
                          message_proportion: t('dashboard.card.percent_messages'),
                        }}
                      />
                    }
                  />
                  <Bar dataKey="message_count" barSize={20} fill="#7C68FB" />
                  <Line type="monotone" dataKey="message_proportion" stroke="#FEC84B" />
                </ComposedChart>
              </ResponsiveContainer>
            ) : (
              <Stack>
                <SvgNoData />
                <Center>
                  <Text color="gray.4">{t('no_data')}</Text>
                </Center>
              </Stack>
            )}
          </Box>

          <ChartTable
            title={t('dashboard.table.chat_pages')}
            customData={{
              head: [
                t('dashboard.table.interaction_name'),
                t('dashboard.table.number_messages'),
                t('dashboard.table.percent_messages'),
              ],
              body: data.map((item) => {
                return {
                  type: item.url,
                  value: [item.message_count, item.message_proportion],
                };
              }),
            }}
            data={[]}
          />
        </Stack>
      </CustomContainer>
    </>
  );
};

export default PopularityInteractions;
